export default __webpack_public_path__ + "static/media/gallery_02.802043c1.jpg";